// extracted by mini-css-extract-plugin
export default {"container":"ReviewArticlesSection_container__NqkuR","articles":"ReviewArticlesSection_articles__sEbyx","articleCard":"ReviewArticlesSection_articleCard__mFQbw"};